import { LivrablePrincipal } from '@shared/models/livrable-principal.enum';

import { SortDefinition } from '../../shared/models/sort-definition';
import { ÉtatRéférentielLivrable } from '../../administration/gestion-référentiels/models/référentiel-livrable.model';

export interface RéférentielLivrableState {
  paginator: { pageNb: number; pageSize: number };
  sorts: SortDefinition[];
  filtres: {
    cartographies?: string[];
    institutsMetiers?: string[];
    services?: string[];
    livrables?: LivrablePrincipal[];
    statuts?: ÉtatRéférentielLivrable[];
    echeance?: 'ONE_WEEK' | 'ONE_MONTH' | 'THREE_MONTHS';
  } | null;
  loading: boolean;
}

export const initialState: RéférentielLivrableState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sorts: [
    {
      direction: '-',
      nom: 'cartographie.nom',
    },
    {
      direction: '+',
      nom: 'referentiel.nom',
    },
    {
      direction: '+',
      nom: 'indice',
    },
  ],
  filtres: null,
  loading: false,
};
